<div
  (dragenter)="onDragEnter($event)"
  [ngClass]="{ notEmpty: inputModel != null }"
>
  <header>
    <button
      (click)="previewToggle($event)"
      [ngClass]="{ playing: isPlayingPreview }"
    >
      {{ isPlayingPreview ? "ON" : "OFF" }}
    </button>
    <span>INPUT {{ index }}</span>
    <button
      (click)="liveToggle($event)"
      class="live"
      [ngClass]="{ playing: isPlayingLive }"
    >
      {{ isPlayingLive ? "ON" : "OFF" }}
    </button>
  </header>

  <div class="cta-wrapper" *ngIf="inputModel == null">
    <svg width="35px" height="35px" viewBox="0 0 35 35">
      <path
        fill-rule="evenodd"
        d="M35.000,18.999 L18.999,18.999 L18.999,35.000 L15.999,35.000 L15.999,18.999 L-0.001,18.999 L-0.001,15.999 L15.999,15.999 L15.999,-0.001 L18.999,-0.001 L18.999,15.999 L35.000,15.999 L35.000,18.999 Z"
      />
    </svg>
    <span>{{ ctaTitle }}</span>
  </div>

  <div class="player-wrapper" *ngIf="inputModel != null">
    <icn-image [url]="inputModel.getThumbnail()"></icn-image>
  </div>

  <div class="soundbar-wrapper">
    <soundbar
      *ngIf="inputModel != null && inputModel.isVideoInput()"
    ></soundbar>
  </div>

  <footer *ngIf="inputModel != null">{{ inputModel.getName() }}</footer>

  <div
    class="drag-mask"
    [hidden]="!isDragOver"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    (dragover)="makeDropAvailableIfNeeded($event)"
  ></div>
</div>
